import { useDispatch } from 'react-redux';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Form, Select, Tabs } from 'antd';
import { LabeledValue } from 'antd/lib/select';
import { ArrowRightOutlined } from '@ant-design/icons';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { IGameEnvModel } from '../../../model/api-modules/env';
import { SystemMenuId } from '../../../model/system/menu';
import { getGamesOptions, getStudioOptions } from '../../utils/admin';
import { Migration } from './migration';
import { GameEnvList } from './table-env';
import { messageError } from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import { fetchAdminEnvList } from '../../../api/admin/game';
export const AdminGameMigration = () => {
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const [loading, setLoading] = useState<boolean>(false);
  const [studioList, setStudioList] = useState<LabeledValue[]>([]);
  const [currentOriginalStudio, setCurrentOriginalStudio] =
    useState<string>('');
  const [currentTargetStudio, setCurrentTargetStudio] = useState<string>('');
  const [currentTargetName, setCurrentTargetName] = useState<string>('');
  const [currentGame, setCurrentGame] = useState<string>('');
  const [currentGameName, setCurrentGameName] = useState<string>('');
  const [gameList, setGameList] = useState<LabeledValue[]>([]);
  const [currentTab, setCurrentTab] = useState<string>(
    getFormatMessage('environments')
  );
  const [envList, setEnvList] = useState<IGameEnvModel[]>([]);

  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.GameMigration,
  });

  const [form] = Form.useForm();

  const getEnvList = async () => {
    setLoading(true);
    const res = await fetchAdminEnvList(currentGame);
    if (res) {
      setEnvList(res);
    } else {
      messageError(getFormatMessage('env_list_fetch_fail'));
    }
    setLoading(false);
  };

  const handleOriginalStudioChange = (value: string) => {
    form.resetFields(['GameId']);
    form.resetFields(['Target StudioID']);
    setCurrentGame('');
    setCurrentTargetStudio('');
    setCurrentOriginalStudio(value);
    if (value) {
      getGamesOptions(value).then((list) => setGameList(list));
    } else {
      setGameList([]);
    }
  };
  const handleGameChange = (value: string, option: any) => {
    if (value) {
      const { label } = option;
      setCurrentGameName(label);
      setCurrentGame(value);
    } else {
      setCurrentGame('');
    }
  };
  const handleTargetStudioChange = (value: string, option: any) => {
    const { label } = option;
    setCurrentTargetStudio(value);
    setCurrentTargetName(label);
    getEnvList();
  };
  const handleMigrationSuccess = () => {
    form.resetFields();
    setCurrentGame('');
    setCurrentTargetStudio('');
    setCurrentOriginalStudio('');
    setGameList([]);
  };

  const handleTabChange = (key: SetStateAction<string>) => {
    setCurrentTab(key);
    getEnvList();
  };
  const filterOption = (inputValue: string, option: any) => {
    const { value, label } = option;
    const searchValue = inputValue.toLowerCase();
    const optionValue = value.toLowerCase();
    const optionLabel = label.toLowerCase();
    return (
      optionValue.includes(searchValue) || optionLabel.includes(searchValue)
    );
  };

  useEffect(() => {
    getStudioOptions().then((list) => setStudioList(list));
  }, []);
  useEffect(() => {
    if (currentOriginalStudio && currentGame && currentTargetStudio) {
      handleTabChange(currentTab);
    }
  }, [currentGame]);
  return (
    <div>
      <div className="migration-select">
        <Form
          className="game-migration-form"
          name="basic"
          autoComplete="off"
          form={form}
        >
          <Form.Item
            name="Original StudioID"
            style={{ marginBottom: '10px', flex: '1' }}
          >
            <span className="migration-select-word">
              {getFormatMessage('migration_org_studio')} ({studioList.length})
            </span>
            <Select
              placeholder={getFormatMessage('select_org_studio')}
              onChange={handleOriginalStudioChange}
              filterOption={filterOption}
              showSearch
            >
              {studioList.map((studio) => (
                <Select.Option
                  value={studio.value}
                  label={studio.label}
                  key={studio.value}
                >
                  <div className="assist-open-select-option">
                    <div className="select-label">{studio.label}</div>
                    <div>{studio.value}</div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="GameId"
            style={{ marginLeft: 8, marginBottom: '10px', flex: '1' }}
          >
            <span className="migration-select-word">
              {getFormatMessage('migration_org_game')} ({gameList.length})
            </span>
            <Select
              placeholder={getFormatMessage('select_org_title')}
              onChange={handleGameChange}
              filterOption={filterOption}
              showSearch
            >
              {gameList.map((game) => (
                <Select.Option
                  value={game.value}
                  label={game.label}
                  key={game.value}
                >
                  <div className="assist-open-select-option">
                    <div className="select-label">{game.label}</div>
                    <div>{game.value}</div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <ArrowRightOutlined
            className="jiantou-icon"
            style={{ color: '#5764F1' }}
          />
          <Form.Item
            name="Target StudioID"
            style={{ marginBottom: '10px', flex: '1' }}
          >
            <span className="migration-select-word">
              {getFormatMessage('migration_tar_studio')}
            </span>
            <Select
              placeholder={getFormatMessage('select_tar_studio')}
              onChange={handleTargetStudioChange}
              filterOption={filterOption}
              showSearch
            >
              {studioList
                .filter((studio) => studio.value !== currentOriginalStudio)
                .map((studio) => (
                  <Select.Option
                    value={studio.value}
                    label={studio.label}
                    key={studio.value}
                  >
                    <div className="assist-open-select-option">
                      <div className="select-label">{studio.label}</div>
                      <div>{studio.value}</div>
                    </div>
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Migration
            onSuccess={handleMigrationSuccess}
            studioId={currentTargetStudio}
            gameId={currentGame}
            gameName={currentGameName}
            studioName={currentTargetName}
          />
        </Form>
      </div>
      {currentOriginalStudio && currentGame && currentTargetStudio && (
        <Tabs activeKey={currentTab} onChange={handleTabChange}>
          <Tabs.TabPane
            tab={getFormatMessage('environments_env_length', {
              params: {
                envListLength: envList.length,
              },
            })}
            key="Environments"
          >
            {/* Environments内容 */}
            <GameEnvList loading={loading} envList={envList || []} />
          </Tabs.TabPane>
        </Tabs>
      )}
    </div>
  );
};
